import axios from 'axios';


const ApiService = async (url, key,angle) => {

    const urlPath = window.location.pathname;
    //const key = urlPath.split('/').pop();

    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/` + url,
            {
                key: key,
                angle:angle,

            },
            {
                headers: {
                    'accept': 'application/json',
                },
            }

        );

        return response.data;
    } catch (error) {
        console.error('Error fetching candidate details:', error);
        throw error;
    }
};


// A distributor sees a cut-down visualizer: only the collections, layouts and
// views their settings allow. The response has the same shape as
// layoutcolorassets, so the rest of the app needs no special case — only the
// question is different.
//
// Two things differ in the request. It addresses a layout by its NUMERIC id,
// not the key the rest of the app passes around; and an empty layoutId asks the
// backend to pick this distributor's first layout, which is how a fresh
// /distributor/<slug> visit starts without knowing any layout yet.
//
// The distributor itself is addressed by the slug set in admin — a string, so
// unlike the layout id it is not coerced to a number.
export const DistributorApiService = async (distributorSlug, layoutId, angle) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/visualizer/distributorcolorassets`,
            {
                slug: String(distributorSlug ?? ''),
                layout_id: layoutId === '' || layoutId == null ? '' : Number(layoutId),
                angle: angle,
            },
            {
                headers: {
                    accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching distributor assets:', error);
        throw error;
    }
};

export default ApiService;